import './EnterpriseHeader.css'
import { translations } from '../../data/translations'

const EnterpriseHeader = ({ language, onLanguageChange }) => {
  const isFrench = language === 'fr'
  const t = translations[language]
  const copy = isFrench
    ? {
        title: 'Questionnaire Website',
        subtitle: 'Formulaire de Decouverte Website Enterprise · par DiGiTaL e.V.',
        motto: '"DiGiTaL e.V. - you can, too."',
        visionTitle: 'Notre Vision',
        visionText: 'Rendre le savoir accessible a tout moment, en tout lieu et pour toutes et tous.',
        missionTitle: 'Notre Mission',
        missionText:
          "Transmettre les competences numeriques necessaires aux personnes dans le besoin afin qu'elles s'epanouissent a l'ere du numerique.",
      }
    : {
        title: 'Website-Fragebogen',
        subtitle: 'Enterprise Website Discovery Formular · von DiGiTaL e.V.',
        motto: '"DiGiTaL e.V. - you can, too."',
        visionTitle: 'Unsere Vision',
        visionText: 'Wissen jederzeit, ueberall und fuer alle Menschen zugaenglich machen.',
        missionTitle: 'Unsere Mission',
        missionText:
          'Digitale Kompetenzen an Menschen in schwierigen Lebenslagen vermitteln, damit sie sich im digitalen Zeitalter entfalten koennen.',
      }

  return (
    <header className="enterprise-header" role="banner">
      <div className="enterprise-header__inner">
        <div className="enterprise-header__top-row">
          <a href="#top" className="enterprise-header__brand" aria-label="DiGiTaL e.V.">
            <img
              src="/logo-digitalev.png"
              alt="DiGiTaL e.V."
              className="enterprise-header__logo"
              onError={(e) => {
                // Fallback for projects that keep the asset in src/assets.
                e.currentTarget.src = '/src/assets/logo-digitalev.png'
              }}
            />
            <div className="enterprise-header__text">
              <h1 className="enterprise-header__title">{copy.title}</h1>
              <p className="enterprise-header__subtitle">{copy.subtitle}</p>
            </div>
          </a>

          <div className="enterprise-header__menu" role="navigation" aria-label={t.ui.headerMenuAriaLabel}>
            <span className="enterprise-header__badge" aria-label={t.ui.headerBadgeAriaLabel}>
              {t.ui.headerBadgeText}
            </span>

            <div className="enterprise-header__language" aria-label={t.ui.languageMenuLabel}>
              <button
                type="button"
                className={`enterprise-header__language-btn ${language === 'de' ? 'is-active' : ''}`}
                onClick={() => onLanguageChange('de')}
                aria-pressed={language === 'de'}
              >
                DE
              </button>
              <button
                type="button"
                className={`enterprise-header__language-btn ${language === 'fr' ? 'is-active' : ''}`}
                onClick={() => onLanguageChange('fr')}
                aria-pressed={language === 'fr'}
              >
                FR
              </button>
            </div>
          </div>
        </div>

        <div className="enterprise-header__statement" aria-label={isFrench ? 'Vision et mission' : 'Vision und Mission'}>
          <p className="enterprise-header__motto">{copy.motto}</p>
          <div className="enterprise-header__pillars">
            <article className="enterprise-header__pillar">
              <h2>{copy.visionTitle}</h2>
              <p>{copy.visionText}</p>
            </article>
            <article className="enterprise-header__pillar">
              <h2>{copy.missionTitle}</h2>
              <p>{copy.missionText}</p>
            </article>
          </div>
        </div>
      </div>
    </header>
  )
}

export default EnterpriseHeader